// extracted by mini-css-extract-plugin
export default {"componentWrapper":"BottomMenu_componentWrapper__6h4pd","menuItem":"BottomMenu_menuItem__E46oL","active":"BottomMenu_active__VlT3B"};